<template>
  <div class="input-group-btn dropdown">
    <button class="btn btn-info btn-outline dropdown-toggle" id="history-search" type="button" style=""
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" @click="getResources">
      <span class="hidden-xs hidden-sm">history</span> <i class="fa fa-history"></i>
    </button>
    <ul class="dropdown-menu text-left" aria-labelledby="history-search">
      <template v-if="history && history.length !== 0">
      <li v-for="(query, key) in history" :key="key">
        <router-link :to="getRoute(query)"><span v-html="queryDisplay(query)"></span></router-link>
      </li>
      </template>
      <li v-else style="font-style: italic">
        <a>no queries performed yet</a>
      </li>
      <li role="separator" class="divider"></li>
      <li>
        <router-link :to="{ name: 'SearchHistory', params:{listId : listId}}">View complete queries history</router-link>
      </li>
    </ul>
  </div>
</template>

<style scoped>
  #history-search {
    width: 100%;
    padding-top: 11px;
    padding-bottom: 10px;
    border-width: 2px;
    border-right-width: 0;
  }
</style>
<script>

import {cleanQueryFromTagsinputToSearch, formatSearchForUrl} from '../../assets/scripts/search'
import Search from '../Mixins/Search'

export default {
  mixins: [Search],
  components: {},
  name: 'History',
  props: [],
  data () {
    return {
      listId: localStorage.getItem('listIdSelected'),
      history: []
    }
  },
  methods: {
    queryDisplay: function (query) {
      let queryDisplay = ''
      let documentType

      switch (query.document_type) {
        case 0:
          documentType = 'science'
          break
        case 1:
          documentType = 'patent'
          break
        case 3:
          documentType = 'company'
          break
        case 4:
          documentType = 'news'
          break
        case 5:
          documentType = 'aichat'
          break
      }

      queryDisplay += '[' + documentType + ']'
      queryDisplay += ' <b>' + query.search_terms.term + '</b>'

      let sources = Object.assign([], query.sources)
      let defaultSource = sources.indexOf('default')
      if (defaultSource !== -1) {
        sources.splice(defaultSource, 1)
      }

      if (sources.length !== 0) {
        sources = sources.join(', ')
        queryDisplay += ' [' + sources + ']'
      }

      if (query.nb_documents !== 120) {
        queryDisplay += ' [' + query.nb_documents + ']'
      }

      if (query.date !== null) {
        queryDisplay += ' [' + query.date['from'] + ' - ' + query.date['to'] + ']'
      }

      if (Array.isArray(query.countries) === true && query.countries !== null) {
        let countries = query.countries.join(', ')
        queryDisplay += ' [' + countries + ']'
      }

      return queryDisplay
    },
    getRoute: function (query) {
      let queryParams = this.prepareSearchWithAdvancedQuery(query)

      queryParams.typeSearched = query.document_type

      let queryClean = cleanQueryFromTagsinputToSearch(query.search_terms.term)
      let queryUrl = formatSearchForUrl(queryClean)

      return { name: 'Search', params: {query: queryUrl}, query: queryParams }
    },
    getResources: function () {
      this.axios.get('search/history?limit=10').then((response) => {
        this.history = response.data
      }).catch((error) => {

      })
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/History.vue